import React, { useEffect, useState } from "react";

import Measurement_Uncertainty_table from "./measurement_Uncertainty_table/Measurement_Uncertainty_table";
import Measurement_Uncertainty_Form from "./measurement_Uncertainty_Form/Measurement_Uncertainty_Form";
import { GetAll } from "../../../../../../../../src/features/admin/quality_management/process_requirement/measurement_uncertainty/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function Measurement({ onNext }) {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const measurementdatadetails = useSelector(
    (state) => state.measurement_type_data,
  );
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: measurementdatadetails.per_page,
      }),
    );
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(
    FixIDS.measurement_uncertainty.List,
  );
  const haveAddPermission = permissions?.includes(
    FixIDS.measurement_uncertainty.Add,
  ); //form

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);
  return (
    <section className="Imperiality">
      <div className="imperiality_Form_div">
        {haveAddPermission && (
          <Measurement_Uncertainty_Form fetchCustomers={fetchCustomers} />
        )}
      </div>

      <div className="imperiality_table_div">
        {haveReadPermission && (
          <Measurement_Uncertainty_table
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            measurementdatadetails={measurementdatadetails}
            fetchCustomers={fetchCustomers}
          />
        )}
      </div>
    </section>
  );
}

export default Measurement;
